import api from "./API";

// Busca ou cria o dia de hoje
export const getHoje = () => api.get('/dias/hoje');

// Lista tarefas do dia
export const getTarefasDoDia = (idDia) =>
  api.get(`/dias/${idDia}/tarefas`);

// Adiciona tarefa ao dia
export const addTarefaAoDia = (idDia, idTarefa) =>
  api.post(`/dias/${idDia}/tarefas`, { id_tarefa: idTarefa });

// Marca/desmarca tarefa do dia
export const toggleTarefaDia = (idDiaTarefa) =>
  api.put(`/dias/tarefas/${idDiaTarefa}`, {});

// Resumo semanal/mensal
export const getResumoDias = (periodo = 'semana') =>
  api.get(`/dias/resumo?periodo=${periodo}`);
